import { useIsFocused, useNavigation } from "@react-navigation/native";
import { useEffect } from "react";

export default function PaymentQRCode({}) {
  const navigaton = useNavigation();
  const isFocus = useIsFocused()
  useEffect(() => isFocus ? navigaton.navigate("ScanQRCode") : null, [isFocus]);
  return;
}
